module.exports = __webpack_public_path__ + "media/images/about-us/PGA/PGA Northern Ohio-323b85a954009cb9de53a91a9875682e.jpg";